function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(-120.000000, -1489.000000)"
}, React.createElement("g", {
  transform: "translate(120.000000, 1184.000000)"
}, React.createElement("g", {
  transform: "translate(0.000000, 305.000000)"
}, React.createElement("path", {
  d: "M192,589 C298.038672,589 384,505.129603 384,401.670225 C384,332.697307 320,198.807232 192,0 C64,198.807232 0,332.697307 0,401.670225 C0,505.129603 85.961328,589 192,589 Z",
  id: "gota"
})))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 384 589"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/big_drop.455a6203.svg";
export { SvgComponent as ReactComponent };